import React, { useEffect, useState } from "react";
import { api } from "../services/api";
import StoreProductCard from "./StoreProductCard";

function ProductSection() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.get("/listings?section=topSelling&limit=12")
      .then((data) => {
        if (mounted) setProducts(data.products || []);
      })
      .catch(() => {
        if (mounted) setProducts([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!products.length) return null;

  return (
    <section className="bg-white py-8">
      <div className="container">
        <h2 className="mb-5 text-left font-gopher text-lg font-bold text-[#3991D5]">Recommended Products</h2>
        <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
          {products.map((product) => (
            <StoreProductCard compact key={product._id || product.sku} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductSection;
